import { AttachMoney, MoneyOff } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

interface CurrencySymbolToggleProps {
  showCurrencySymbol: boolean;
  setShowCurrencySymbol: (show: boolean) => void;
}

export function CurrencySymbolToggle({
  showCurrencySymbol,
  setShowCurrencySymbol,
}: CurrencySymbolToggleProps) {
  if (showCurrencySymbol) {
    return (
      <Tooltip title={ `Click to remove currency symbols from report` }>
        <IconButton
          onClick={ () => setShowCurrencySymbol(false) }
        >
          <AttachMoney
            fontSize={ `medium` }
          />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={ `Click to show currency symbols in report` }>
      <IconButton
        onClick={ () => setShowCurrencySymbol(true) }
      >
        <MoneyOff
          fontSize={ `medium` }
        />
      </IconButton>
    </Tooltip>
  );
}
